const fileServiceName = '/File';

export function fileService (http) {
    return {
        getFolderFileAsync: async parentId => {
            let parameters = {
                parentId
            };

            return await http.post(fileServiceName + '/GetFolderFilesAsync', parameters);
        },
    }
}